/* Polna · korekta v4 (30.09). Tekst jasnych sekcji zanika, gdy tło strony przechodzi w zieleń lub bordo.
   v4.js ustawia na .bgfx --bg-g i --bg-b (0..1); tutaj z nich powstaje --ink-o na <html>. */
const bgfx = document.querySelector('.bgfx');
if (bgfx) {
  const root = document.documentElement;
  const ss = (a, b, x) => { const t = Math.max(0, Math.min(1, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
  let last = '';
  const sync = () => {
    const s = bgfx.style;
    const d = Math.max(Number(s.getPropertyValue('--bg-g')) || 0, Number(s.getPropertyValue('--bg-b')) || 0);
    const o = (1 - ss(0.12, 0.55, d)).toFixed(3);
    if (o !== last) { last = o; root.style.setProperty('--ink-o', o); }
  };
  new MutationObserver(sync).observe(bgfx, { attributes: true, attributeFilter: ['style'] });
  sync();
}
